module.exports = __webpack_public_path__ + "img/slide6.1d0e88e6.png";